import React, { Fragment } from "react";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import CustomerProfile from "../components/CustomerProfile";
import EditCustomerProfile from "../components/EditCustomerProfile";
import { getCustomerProfile } from "../actions/customerAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

class CustomerContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getCustomerProfile(this.props.match.params.id);
  }
  render() {
    const { loading, customer } = this.props.customer;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            className="mt-2"
            id="left-tabs-example"
            defaultActiveKey="profile"
            mountOnEnter
            unmountOnExit
          >
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="profile">Customer Profile</Nav.Link>
                  </Nav.Item>
                  <LinkContainer exact to="/edit_profile/:id">
                    <Nav.Item>
                      <Nav.Link eventKey="edit_profile">
                        Edit Customer Profile
                      </Nav.Link>
                    </Nav.Item>
                  </LinkContainer>
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="profile">
                      <CustomerProfile customer={customer} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="edit_profile">
                      <EditCustomerProfile customer={customer} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ customer }) => ({
  customer: customer,
});
const mapDispatchToProps = (dispatch) => ({
  getCustomerProfile: (customer) => dispatch(getCustomerProfile(customer)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CustomerContainer);
